import type { RouteComponentProps } from "react-router-dom";

import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry<RouteComponentProps<{ patient_id: string }>>(() => import("./patient-view-page"), {
  testId: "rd-patient-view-loading-chunk",
  shell: (props) => {
    const patientId = props.match?.params?.patient_id;
    return {
      activeNav: "patients",
      breadcrumbLeaf: patientId ? { id: "redesign.shell.patient", defaultMessage: "Patient {id}", values: { id: patientId } } : undefined,
    };
  },
});
